/**
 * Ein Ladezustand für den ganzen Bereich: großes Drehsymbol + Text in der Mitte. Owner 11.09.2026 / 09.10.2026: den
 * schmalen Ladebalken oben sieht niemand — wer auf Daten wartet, muss es im Bereich selbst sehen, nicht einen leeren
 * Zustand, der etwas Falsches behauptet.
 */
export function LadeAnzeige({ text }: { text: string }) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3" role="status" aria-live="polite">
      <span className="material-symbols-outlined animate-spin !text-[48px] text-on-surface" aria-hidden="true">
        progress_activity
      </span>
      <p className="text-base text-on-surface">{text}</p>
    </div>
  )
}
